module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/admin/users/admin-user-detail.component.scss
// module id = ./src/app/admin/users/admin-user-detail.component.scss
// module chunks = main